import { React, useState, useEffect } from "react";
import classes from "./MainBlogsCard.module.scss";
import { ClockCircleOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
const FeaturedBlogCard = (props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/blogs/" + props.id);
  };

  return (
    <div onClick={handleClick} className={classes.card}>
      <div className={classes.cardImage}>
        <img src={props.image} alt={props.title} />
      </div>
      <div className={classes.cardContent}>
        <h2 className={classes.cardTitle}>{props.title}</h2>
        <p className={classes.cardpublishdate}>
          <ClockCircleOutlined />
          {props.date}
        </p>
        <p className={classes.cardReadMore}>Read More</p>

        {/* <p className={classes.cardText}>{props.content}</p> */}
        {/* <div className={classes.cardBottom}>
          <p className={classes.cardAuthor}>By {props.author}</p>
          <div className={classes.cardButton}>
            <button className={classes.cardReadMore}>View More</button>
            <ArrowForwardIcon className={classes.cardButtonIcon} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default FeaturedBlogCard;
